/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-30 22:10:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 14:59:26
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/CompositionInput/index.tsx
 */
//const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
//主要为了解决中文输入法的问题
import React from 'react';
import Input from '../Input/Input';
import TextArea from 'src/components/Antd/TextArea/TextArea';

const CompositionInput = (props) => {
  const { value, onChange, customFilter, ...rest } = props;

  const [input, setInput] = React.useState(value);
  const _isC = React.useRef(false);

  React.useEffect(() => {
    setInput(value);
  }, [value]);

  const filterValue = (text) => {
    if (customFilter) {
      const _v = customFilter(text);
      return _v;
    }
    return text;
  };

  const handleOnChange = (v, e) => {
    if (!_isC.current && onChange) {
      const _v = filterValue(v);
      onChange(_v, e);
    } else {
      setInput(v);
    }
  };

  const handleCompositionStart = (e) => {
    if (e.type === 'compositionstart') {
      _isC.current = true;
    }
  };

  const handleComposition = (ev) => {
    if (ev.type === 'compositionend') {
      _isC.current = false;
      const _input = filterValue(input);

      if (_input == value) {
        setInput(_input);
      } else {
        onChange(_input, ev);
      }
    } else {
      _isC.current = true;
    }
  };

  return (
    <Input
      value={input}
      onChange={handleOnChange}
      onCompositionStart={handleCompositionStart}
      onCompositionEnd={handleComposition}
      {...rest}
    />
  );
};

const CompositionTextArea = (props) => {
  const { value, onChange, customFilter, ...rest } = props;

  const [input, setInput] = React.useState(value);
  const _isC = React.useRef(false);

  React.useEffect(() => {
    setInput(value);
  }, [value]);

  const filterValue = (text) => {
    if (customFilter) {
      const _v = customFilter(text);
      return _v;
    }
    return text;
  };

  const handleOnChange = (v, e) => {
    if (!_isC.current && onChange) {
      const _v = filterValue(v);
      onChange(_v, e);
    } else {
      setInput(v);
    }
  };

  const handleCompositionStart = (e) => {
    if (e.type === 'compositionstart') {
      _isC.current = true;
    }
  };

  const handleComposition = (ev) => {
    if (ev.type === 'compositionend') {
      _isC.current = false;
      const _input = filterValue(input);

      if (_input == value) {
        setInput(_input);
      } else {
        onChange(_input, ev);
      }
    } else {
      _isC.current = true;
    }
  };

  return (
    <TextArea
      value={input}
      onChange={handleOnChange}
      onCompositionStart={handleCompositionStart}
      onCompositionEnd={handleComposition}
      {...rest}
    />
  );
};

CompositionInput.TextArea = CompositionTextArea;

export default CompositionInput;
